import React, { useContext } from 'react';
import { array, bool, string } from 'prop-types';
import { Converse, Jordan } from '@nike/nike-design-system-icons';
import Link from '../Link';
import { DEFAULT_JORDAN_LINK, MENU_TYPES, DATA_TYPES, BODEGA_DEFAULTS } from './../../constants';
import { StyledUl, brandLinkClass, jordanClass, converseClass } from './styles';
import useMenuData from '../../utils/hooks/cmsDataHook';
import useBodega from '../../utils/hooks/bodegaHook';
import { AnalyticsContext } from '../../context/analyticsContext';

const BrandMenu = props => {
  const { brandListWrapperClass, displayTitles } = props;
  const { BRAND_NAVIGATION } = BODEGA_DEFAULTS;
  const brandNavigationLabel = useBodega('nav_header_brand_navigation', BRAND_NAVIGATION);
  const { analyticsClient } = useContext(AnalyticsContext);

  const brandMenuData = useMenuData(DATA_TYPES.HEADER, MENU_TYPES.BRAND_MENU)?.children;
  const iconList = brandMenuData?.map(menuData => {
    const path = menuData?.path;
    return {
      brandClass: path?.includes('jordan') ? jordanClass : converseClass,
      component: path?.includes('jordan') ? Jordan : Converse,
      href: path?.includes('jordan') ? menuData?.url || DEFAULT_JORDAN_LINK : menuData?.url,
      label: menuData?.label,
      key: menuData?.label,
      hashKey: menuData?.hashKey,
    };
  });

  return (
    <nav aria-label={brandNavigationLabel}>
      <StyledUl className={brandListWrapperClass}>
        {iconList?.map(componentObj => (
          <li key={componentObj.key}>
            <Link
              ariaLabel={componentObj.label}
              className={brandLinkClass}
              href={componentObj.href}
              onClick={() => {
                analyticsClient?.clickNavBrandBar({
                  label: componentObj.label,
                  hashKey: componentObj.hashKey,
                });
              }}
            >
              <componentObj.component size="m" />
              {displayTitles && <p>{componentObj?.label}</p>}
            </Link>
          </li>
        ))}
      </StyledUl>
    </nav>
  );
};

export default BrandMenu;

BrandMenu.propTypes = {
  brandMenuData: array,
  brandListWrapperClass: string,
  displayTitles: bool,
};
